import React from 'react';
import { formatValue, formatConfidence } from '../../utils/formatters';

const NavigationStructureSection = ({ navigationStructure }) => {



    if (!navigationStructure || typeof navigationStructure !== 'object') {
        return null;
    }
    console.log('navigationStructure', navigationStructure);

    const hasContent = 
        navigationStructure.navigation_structure.primary_navigation ||
        navigationStructure.navigation_structure.footer_navigation ||
        navigationStructure.navigation_structure.breadcrumb_navigation ||
        navigationStructure.navigation_structure.secondary_navigation;


    if (!hasContent) {
        return null;
    }



    const renderNavigationItem = (item, index) => {
        return (
            <div
                key={index}
                style={{
                    padding: '8px 12px',
                    backgroundColor: '#262626',
                    border: '1px solid #373737',
                    borderRadius: '4px',
                    marginBottom: '6px'
                }}
            >
                <div style={{
                    fontSize: '13px',
                    fontWeight: '500',
                    color: '#e0e0e0',
                    marginBottom: '4px'
                }}>
                    {item.label || 'Unlabeled'}
                </div>
                {item.url && (
                    <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{
                            fontSize: '12px',
                            color: '#60a5fa',
                            textDecoration: 'none',
                            wordBreak: 'break-all'
                        }}
                        onMouseEnter={(e) => e.target.style.textDecoration = 'underline'}
                        onMouseLeave={(e) => e.target.style.textDecoration = 'none'}
                    >
                        {item.url}
                    </a>
                )}
            </div>
        );
    };

    const renderNavigationBlock = (title, navData, showLocation = false) => {
        if (!navData) return null;

        const items = navData.items || [];
        const groups = navData.groups || [];
        const confidence = navData.confidence;
        const location = navData.location;
        const pattern = navData.pattern;

        return (
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '8px',
                padding: '16px',
                marginBottom: '16px'
            }}>
                <div style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '12px'
                }}>
                    <h5 style={{
                        fontSize: '14px',
                        fontWeight: '600',
                        color: '#e0e0e0',
                        margin: 0
                    }}>
                        {title}
                        {navData.label && navData.label !== title && (
                            <span style={{
                                fontSize: '12px',
                                fontWeight: '400',
                                color: '#a0a0a0',
                                marginLeft: '8px'
                            }}>
                                ({navData.label})
                            </span>
                        )}
                    </h5>
                    {confidence !== undefined && confidence !== null && (
                        <span style={{
                            fontSize: '11px',
                            color: '#909090',
                            backgroundColor: '#1a1a1a',
                            padding: '4px 8px',
                            borderRadius: '4px'
                        }}>
                            {formatConfidence(confidence)}
                        </span>
                    )}
                </div>

                {showLocation && location && (
                    <div style={{
                        fontSize: '12px',
                        color: '#a0a0a0',
                        marginBottom: '12px',
                        padding: '6px 10px',
                        backgroundColor: '#262626',
                        borderRadius: '4px',
                        display: 'inline-block'
                    }}>
                        Location: {formatValue(location)}
                    </div>
                )}

                {pattern && (
                    <div style={{
                        fontSize: '12px',
                        color: '#a0a0a0',
                        fontStyle: 'italic',
                        marginBottom: '12px',
                        padding: '8px',
                        backgroundColor: '#262626',
                        borderRadius: '4px'
                    }}>
                        {formatValue(pattern)}
                    </div>
                )}

                {items.length > 0 && (
                    <div style={{ marginTop: '12px' }}>
                        <div style={{
                            fontSize: '11px',
                            color: '#909090',
                            textTransform: 'uppercase',
                            marginBottom: '8px',
                            fontWeight: '600',
                            letterSpacing: '0.5px'
                        }}>
                            Items ({items.length})
                        </div>
                        {items.map((item, index) => renderNavigationItem(item, index))}
                    </div>
                )}

                {groups.length > 0 && (
                    <div style={{ marginTop: '12px' }}>
                        {groups.map((group, groupIndex) => (
                            <div key={groupIndex} style={{ marginBottom: '16px' }}>
                                <div style={{
                                    fontSize: '12px',
                                    fontWeight: '600',
                                    color: '#c0c0c0',
                                    marginBottom: '8px'
                                }}>
                                    {group.label || `Group ${groupIndex + 1}`}
                                    {group.location && (
                                        <span style={{
                                            fontSize: '11px',
                                            fontWeight: '400',
                                            color: '#909090',
                                            marginLeft: '8px'
                                        }}>
                                            ({formatValue(group.location)})
                                        </span>
                                    )}
                                </div>
                                {group.items && group.items.length > 0 && (
                                    <div>
                                        {group.items.map((item, itemIndex) => 
                                            renderNavigationItem(item, `${groupIndex}-${itemIndex}`)
                                        )}
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}

                {items.length === 0 && groups.length === 0 && !pattern && (
                    <div style={{
                        fontSize: '12px',
                        color: '#909090',
                        fontStyle: 'italic'
                    }}>
                        No navigation items found
                    </div>
                )}
            </div>
        );
    };

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>
                Navigation Structure
            </h4>
            <div style={{
                backgroundColor: '#2d2d2d',
                border: '1px solid #404040',
                borderRadius: '8px',
                padding: '20px'
            }}>
                {renderNavigationBlock('Primary Navigation', navigationStructure.navigation_structure.primary_navigation, true)}
                {renderNavigationBlock('Footer Navigation', navigationStructure.navigation_structure.footer_navigation)}
                {renderNavigationBlock('Breadcrumb Navigation', navigationStructure.navigation_structure.breadcrumb_navigation)}
                {renderNavigationBlock('Secondary Navigation', navigationStructure.navigation_structure.secondary_navigation)}
            </div>
        </div>
    );
};

export default NavigationStructureSection;

